// Defines routes for all webpages
export const HOMEPAGE = "/";
export const TASKS = "/tasks/";
export const ADMIN = "/admin/";
export const EDISON_ADMIN = "/edison-admin/";
